import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { css } from "@emotion/react";
import Tab from "@mui/material/Tab";

import { colors } from "@dotnet/telematics-design-system";

import Tabs from "components/DesignComponents/Tabs";

import { TabFiltersProps } from "./types";

const TabFilters = ({ tableName, tabs }: TabFiltersProps) => {
    const { gray200 } = colors;

    const { t } = useTranslation();
    const navigate = useNavigate();

    const tabIndex = tabs.findIndex(tab => tab.route === tableName);

    return (
        <div
            css={css({
                padding: "8px 24px 0 24px",
                boxShadow: `inset 0px -1px 0px ${gray200}`
            })}
        >
            <Tabs value={tabIndex}>
                {tabs.map(({ label, route }) => (
                    <Tab
                        key={route}
                        label={t(`General##${label}`)}
                        onClick={() => {
                            navigate(route);
                        }}
                    />
                ))}
            </Tabs>
        </div>
    );
};

export { TabFilters };
